const updateCropZoneGeoJson = (cropZone, allFFTGeoJson) => {
  return {
    type: allFFTGeoJson.type, // Preserve the type
    features: [
      ...allFFTGeoJson.features, // Spread the existing features
      {
        type: 'Feature',
        geometry: cropZone.geometry,
        properties: {
          id: cropZone.id,
          name: cropZone.name,
          cropId: cropZone.cropId,
          reportedArea: cropZone.reportedArea,
          fieldId: cropZone.fieldId,
          propertyId: cropZone.propertyId,
          cropSeasonId: cropZone.cropSeasonId || null, // this geo does not get saved, only for display
          $landType: 'cropzone',
          $layer: 'focused'
        }
      }
    ]
  };
};

export default updateCropZoneGeoJson;
